import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';

import { ObjetivoCampanhaBadgeVendaComponent } from './venda';
import { ObjetivoCampanhaBadgeBonificacaoComponent } from './bonificacao';
import { ObjetivoCampanhaBadgeAquisicaoComponent } from './aquisicao';
import { ObjetivoCampanhaBadgesComponent } from './objetivo-campanha-badges.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ObjetivoCampanhaBadgeVendaComponent,
        ObjetivoCampanhaBadgeBonificacaoComponent,
        ObjetivoCampanhaBadgeAquisicaoComponent,
        ObjetivoCampanhaBadgesComponent
    ],
    exports: [
        ObjetivoCampanhaBadgeVendaComponent,
        ObjetivoCampanhaBadgeBonificacaoComponent,
        ObjetivoCampanhaBadgeAquisicaoComponent,
        ObjetivoCampanhaBadgesComponent
    ]
})
export class ObjetivoCampanhaBadgesModule { }
